import { themeGet } from '@styled-system/theme-get'
import { Dropdown } from 'react-bootstrap'
import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const DropdownMenuStyle = css`
  padding: 4px;
  border: 1px solid ${palette.neutral['100']};
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: ${palette.neutral.white};
`

export const DropdownMenuItemStyle = css`
  font-size: 14px;
  font-weight: 400;
  height: 24px;
  border: none;
  border-radius: 8px;
  padding: 16px 8px;
  margin-bottom: 2px;
  width: 100%;
  &[aria-expanded='true'],
  &[aria-expanded='true']:hover {
    background-color: ${palette.neutral['500']};
    color: ${palette.neutral.white};
    svg {
      path {
        fill: ${palette.neutral.white};
      }
    }
  }
  &:hover {
    background: ${themeGet('colors.bg.neutral')};
    color: ${palette.neutral['900']};
    svg {
      path {
        fill: ${palette.neutral['500']};
      }
    }
  }
`

export const DropDownMenu = styled(Dropdown.Menu).attrs({
  rootCloseEvent: 'mousedown',
})`
  ${DropdownMenuStyle}
`

export const NestedDropdownMenu = styled.div.attrs({
  className: 'dropdown-menu',
})<{
  $hasNested?: boolean
}>`
  position: absolute;
  left: 100%;
  top: 0;
  display: flex;
  flex-direction: column;
  min-width: 240px;
  max-height: 400px;
  overflow: hidden;
  ${DropdownMenuStyle}
  ${({ $hasNested }) =>
    $hasNested &&
    `overflow: visible !important;
  max-height: fit-content !important;`}
`

export const NestedFilterItemsContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 350px;
  flex: 1;
`

export const FilterOptionContainer = styled.div``

// A category heading over a group of options.
export const FilterGroupHeading = styled.div`
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${palette.neutral['700']};
  padding: 10px 8px 4px;
`

export const FilterItemsContainer = styled.div`
  overflow-y: auto;
  max-height: 350px;
`

export const DropDownMenuWithNesting = styled(Dropdown.Menu).attrs({
  rootCloseEvent: 'mousedown',
})<{
  $hasNested: boolean
}>`
  ${DropdownMenuStyle}
  ${({ $hasNested }) =>
    $hasNested &&
    `overflow: visible !important;
  max-height: fit-content !important;`}
`

export const FilterDropdownIcon = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  svg {
    width: 16px;
    height: 16px;
  }
`
